import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend, { type BackendError } from "@/utils/fetchToBackend";
import { contractingKeys } from "@/lib/query-keys";
import { toastUtil } from "@/utils/toastUtil";

/**
 * Invalida también detalles y listados: cambiar la ficha deja viejos los
 * cruces, y la pestaña de requisitos y el badge de calificación tienen que enterarse.
 */
function invalidateCompanyDocuments(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: contractingKeys.companyDocuments() });
  qc.invalidateQueries({ queryKey: contractingKeys.details() });
  qc.invalidateQueries({ queryKey: contractingKeys.lists() });
  qc.invalidateQueries({ queryKey: contractingKeys.qualification() });
}

/** Sube un documento de la propia empresa. Va en base64, igual que el admin. */
export function useUploadMyCompanyDocument() {
  const qc = useQueryClient();
  return useMutation<
    { id: number },
    BackendError,
    { fileName: string; base64Data: string }
  >({
    mutationFn: (input) =>
      fetchToBackend("/organization/documents", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => invalidateCompanyDocuments(qc),
    onError: (error, { fileName }) =>
      toastUtil(error.message || `No se pudo subir ${fileName}.`, "error"),
  });
}

/** Quita un documento de la ficha. El backend lo desactiva, no lo borra. */
export function useRemoveMyCompanyDocument() {
  const qc = useQueryClient();
  return useMutation<unknown, BackendError, { documentId: number }>({
    mutationFn: ({ documentId }) =>
      fetchToBackend(`/organization/documents/${documentId}`, {
        method: "DELETE",
      }),
    onSuccess: () => invalidateCompanyDocuments(qc),
    onError: (error) =>
      toastUtil(error.message || "No se pudo quitar el documento.", "error"),
  });
}
